import { createContext, useContext, useState, useEffect, useMemo } from "react";

const UnitsContext = createContext(null);

export function UnitsProvider({ children }) {
  const [units, setUnits] = useState(() => localStorage.getItem("units") || "field");
  useEffect(() => {
    localStorage.setItem("units", units);
  }, [units]);
  const value = useMemo(() => ({ units, setUnits }), [units]);
  return (
    <UnitsContext.Provider value={value}>
      {children}
    </UnitsContext.Provider>
  );
}

export function useUnits() {
  return useContext(UnitsContext);
}

// Labels per units system
export const L = (units) => ({
  pressure: units === "field" ? "psi" : "bar",
  density: units === "field" ? "ppg" : "kg/m³",
  length: units === "field" ? "ft" : "m",
  diameter: units === "field" ? "in" : "mm",
  volume: units === "field" ? "bbl" : "L",
  temp: units === "field" ? "°F" : "°C",
  capacity: units === "field" ? "bbl/ft" : "L/m",
});
